jQuery(document).ready(function ($) {

    $('.hamburger').on('click', function () {
        $("body").toggleClass("nav-open");
        $("html").toggleClass("not-scrollable");
        $('.hamburger-wrapper').toggleClass('hamburger-wrapper--animate');
    })

    $('.toggle-search').on('click', function () {
        $("body").toggleClass("search-open");
        $("html").toggleClass("not-scrollable");
    });

    $('.modal-background').click(function () {
        $('body').removeClass('search-open');
    });

    $('.navbar li.menu-item-has-children > a').append('<i class="fa-solid fa-angle-down ms-2 w-1 transition-primary"></i>');

    $('.hamburger-menu .menu-container .menu-item-has-children').append('<span class="more"><i class="fa-solid fa-arrow-right w-2 h-2 text-white"></i></span>');
    $('<li><a class="back"><i class="fa-solid fa-arrow-left text-primary me-4"></i><span>Terug</span></a><li>').insertBefore('.hamburger-menu .menu-container .menu-item-has-children .sub-menu li:first-child');

    $('.hamburger-menu .menu-container .more').click(function () {
        $('html').addClass('sub-menu-active');
        $(this).closest('li').addClass('children-active');
        $(this).closest('ul.sub-menu').addClass('submenu-active');
    });

    $('.hamburger-menu .menu-container .back').click(function () {
        $('html').removeClass('sub-menu-active');
        $(this).closest('li.children-active').removeClass('children-active');
        $(this).closest('ul.sub-menu.submenu-active').removeClass('submenu-active');
    });

    $(document).on('facetwp-refresh', function () {
        if (FWP.soft_refresh == true) {
            FWP.enable_scroll = true;
        } else {
            FWP.enable_scroll = false;
        }
    });

    if ($(window).width() <= 992) {
        $('.tents-desktop').remove();
    } else {
        $('.tents-mobile').remove();
    }

    $(document).on('facetwp-loaded', function () {
        if (FWP.enable_scroll == true) {
            $('html, body').animate({
                scrollTop: 0
            }, 600);
        }
    });

    // https://facetwp.com/fade-template-content-during-refresh/
    $(document).on('facetwp-refresh', function () {
        $('.facetwp-template').animate({
            opacity: 0
        }, 300); // Fade out with a duration of 600 milliseconds: adapt as needed
    });

    $(document).on('facetwp-loaded', function () {
        $('.facetwp-template').animate({
            opacity: 1
        }, 300); // Fade in with a duration of 600 milliseconds: adapt as needed
    });

    // Select all links with hashes
    $('a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function (event) {
            // On-page links
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
                location.hostname == this.hostname
            ) {
                // Figure out element to scroll to
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top - 100
                    }, 600, function () {
                        // Callback after animation
                        // Must change focus!
                        var $target = $(target);
                        $target.focus();
                    });
                }
            }
        });

});
